import React, { useState } from 'react';
import GoalStrengthAdd from './GoalStrengthAdd';

const GoalStrength = ({ goal, unit, exercises, setFieldValue, errors, values, setFieldTouched }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [previous, setPrevious] = useState();

  return (
    <div className="goal-block goal-block-strength">
      <div className="goal-icon">
        <i className="fas fa-dumbbell"></i>
        <label>Performance</label>
      </div>
      <div className="goal-info">
        {
        goal?.type === 'Other' ?
          <p>{`
            ${goal?.description ? goal.description : ''} 
            ${goal?.goal ? goal.goal : ''}
            ${goal?.goal_unit ? goal.goal_unit : ''}
          `}</p>
          :
          <p>{`
            ${goal?.exercise_name ? goal.exercise_name : ''} 
            ${goal?.max_lift ? `${goal.max_lift} ${unit}` : ''}
          `}</p>
        }
      </div>
      <a
        href="javascript:;"
        className="edit-goal"
        onClick={() => {
            setModalOpen(true)
            setPrevious({ ...goal })
          }
        }
        type="button"
      >
        <i className="fas fa-pen"></i>
      </a>
      <GoalStrengthAdd
        openModal={modalOpen}
        setModalOpen={setModalOpen}
        setFieldValue={setFieldValue}
        goal={previous} exercises={exercises}
        errors={errors}
        values={values}
        setFieldTouched={setFieldTouched}
      />
    </div>
  );
};

export default GoalStrength;
